/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type LinkAccountTerminalApplicationGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type LinkAccountTerminalApplicationRequest = {
  accountID: string;
  linkAccountTerminalApplication: components.LinkAccountTerminalApplication;
};

export type LinkAccountTerminalApplicationResponse = {
  headers: { [k: string]: Array<string> };
  result: components.AccountTerminalApplication;
};

/** @internal */
export const LinkAccountTerminalApplicationGlobals$inboundSchema: z.ZodType<
  LinkAccountTerminalApplicationGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type LinkAccountTerminalApplicationGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const LinkAccountTerminalApplicationGlobals$outboundSchema: z.ZodType<
  LinkAccountTerminalApplicationGlobals$Outbound,
  z.ZodTypeDef,
  LinkAccountTerminalApplicationGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function linkAccountTerminalApplicationGlobalsToJSON(
  linkAccountTerminalApplicationGlobals: LinkAccountTerminalApplicationGlobals,
): string {
  return JSON.stringify(
    LinkAccountTerminalApplicationGlobals$outboundSchema.parse(
      linkAccountTerminalApplicationGlobals,
    ),
  );
}
export function linkAccountTerminalApplicationGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<LinkAccountTerminalApplicationGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      LinkAccountTerminalApplicationGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LinkAccountTerminalApplicationGlobals' from JSON`,
  );
}

/** @internal */
export const LinkAccountTerminalApplicationRequest$inboundSchema: z.ZodType<
  LinkAccountTerminalApplicationRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
  LinkAccountTerminalApplication:
    components.LinkAccountTerminalApplication$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "LinkAccountTerminalApplication": "linkAccountTerminalApplication",
  });
});
/** @internal */
export type LinkAccountTerminalApplicationRequest$Outbound = {
  accountID: string;
  LinkAccountTerminalApplication:
    components.LinkAccountTerminalApplication$Outbound;
};

/** @internal */
export const LinkAccountTerminalApplicationRequest$outboundSchema: z.ZodType<
  LinkAccountTerminalApplicationRequest$Outbound,
  z.ZodTypeDef,
  LinkAccountTerminalApplicationRequest
> = z.object({
  accountID: z.string(),
  linkAccountTerminalApplication:
    components.LinkAccountTerminalApplication$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    linkAccountTerminalApplication: "LinkAccountTerminalApplication",
  });
});

export function linkAccountTerminalApplicationRequestToJSON(
  linkAccountTerminalApplicationRequest: LinkAccountTerminalApplicationRequest,
): string {
  return JSON.stringify(
    LinkAccountTerminalApplicationRequest$outboundSchema.parse(
      linkAccountTerminalApplicationRequest,
    ),
  );
}
export function linkAccountTerminalApplicationRequestFromJSON(
  jsonString: string,
): SafeParseResult<LinkAccountTerminalApplicationRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      LinkAccountTerminalApplicationRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LinkAccountTerminalApplicationRequest' from JSON`,
  );
}

/** @internal */
export const LinkAccountTerminalApplicationResponse$inboundSchema: z.ZodType<
  LinkAccountTerminalApplicationResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: components.AccountTerminalApplication$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type LinkAccountTerminalApplicationResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: components.AccountTerminalApplication$Outbound;
};

/** @internal */
export const LinkAccountTerminalApplicationResponse$outboundSchema: z.ZodType<
  LinkAccountTerminalApplicationResponse$Outbound,
  z.ZodTypeDef,
  LinkAccountTerminalApplicationResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: components.AccountTerminalApplication$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function linkAccountTerminalApplicationResponseToJSON(
  linkAccountTerminalApplicationResponse:
    LinkAccountTerminalApplicationResponse,
): string {
  return JSON.stringify(
    LinkAccountTerminalApplicationResponse$outboundSchema.parse(
      linkAccountTerminalApplicationResponse,
    ),
  );
}
export function linkAccountTerminalApplicationResponseFromJSON(
  jsonString: string,
): SafeParseResult<LinkAccountTerminalApplicationResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      LinkAccountTerminalApplicationResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LinkAccountTerminalApplicationResponse' from JSON`,
  );
}
